export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const SET_LOADING = "SET_LOADING";
export const SET_ALL_USERS = "SET_ALL_USERS";
